<div class="lk-overlay-toggle" data-test-id="locks-keys-overlay-toggle">
  <span class="lk-overlay-toggle__label">{{ t('summary.overlayLabel') }}</span>
  <e-segmented-toggle
    class="lk-overlay-toggle__segment"
    size="xs"
    testId="locks-keys-overlay"
    [groupLabel]="t('summary.overlayLabel')"
    [options]="options()"
    [value]="mode()"
    (valueChange)="select($event)"
  ></e-segmented-toggle>
</div>
